<template>
	<div >
		<div class="page_header">
			<span class="page_title">{{ $t('龙翼简报.车辆信息') }}</span>
			<el-form class="vehicleclass" :inline="true" :size="size" style="flex:1;text-align: right;">

				<el-form-item :label="$t('vehicleInfo.vehiclesearch') + '：'">
					<el-input v-model="vehicleInfo" :placeholder="$t('public.vehicleInputTips')" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="onSubmit(vehicleInfo)">{{ $t('public.query') }}</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="page_container" style="height: calc(100vh - 250px); overflow-y: auto;">
			<el-table :size="size" :data="tableData" border style="width: 100%" v-loading="loading">
				<el-table-column align="center" width="60" :label="$t('public.index')">
					<template slot-scope="scope">
						{{ (scope.$index + 1) + (current_event_page - 1) * pageSize }}
					</template>
				</el-table-column>
				<el-table-column prop="vin" align="center" :label="$t('vehicleInfo.vin')" width="160">
				</el-table-column>
				<el-table-column prop="manufactureId" align="center" :label="$t('vehicleInfo.manufactureId')"
					width="120">
				</el-table-column>

				<el-table-column prop="vehicleModel" align="center" :label="$t('vehicle.VehicleModel')" width="150">
				</el-table-column>
				<el-table-column prop="carno" align="center" :label="$t('vehicle.carNo')" width="120">
				</el-table-column>
				<el-table-column prop="driver" align="center" :label="$t('vehicleInfo.driver')" width="100">
				</el-table-column>
				<el-table-column prop="deviceNo" align="center" :label="$t('vehicle.DeviceNo')" width="160">
				</el-table-column>
				<el-table-column prop="telphoneNo" align="center" :label="$t('vehicle.Mobile')" width="160">
				</el-table-column>
				<el-table-column prop="runState" align="center" :label="$t('vehicleInfo.operationalstatus')"
					width="160">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.runState == 1" size="mini" type="success">{{
							$t('vehicleInfo.caroperate') }}</el-tag>
						<el-tag v-if="scope.row.runState == 2" size="mini" type="warning">{{ $t('vehicleInfo.维修')
						}}</el-tag>
						<el-tag v-if="scope.row.runState == 0" size="mini" type="danger">{{ $t('vehicleInfo.停运')
						}}</el-tag>

					</template>
				</el-table-column>

				<el-table-column prop="buydate" align="center" :label="$t('vehicleInfo.buydate')" width="160">
					<template slot-scope="scope">
						{{ scope.row.buydate == '1900-01-01 00:00:00' ? '' : scope.row.buydate }}
					</template>
				</el-table-column>
				<el-table-column prop="QRCodeUrl" align="center" label="车辆二维码" width="160">
					<template slot-scope="scope">
						<el-image style="width:64px; height: 64px" :src="scope.row.QRCodeUrl"
							:preview-src-list="[scope.row.QRCodeUrl]">
						</el-image>
					</template>
				</el-table-column>

				<!-- <el-table-column :label="$t('vehicleInfo.accessoriesInfo')" align="center" fixed="right">
					<template slot-scope="scope">
						<el-button @click="viewClick(scope.row)" type="text"
							size="small">{{$t('vehicleInfo.view')}}</el-button>

					</template>
				</el-table-column> -->
				<el-table-column :label="$t('public.edit')" align="center" fixed="right">
					<template slot-scope="scope">
						<i class="el-icon-edit-outline" @click="modifyClick(scope.row)"
							style="color: #2A7AFF;height: 12px;width: 12px;"></i>

					</template>
				</el-table-column>
			</el-table>
			<kl-pagination :total="totalEventCount" :page-size="pageSize" @current-change="handleEventCurrentChange"
				:current-page.sync="current_event_page">
			</kl-pagination>
			<el-dialog class="dialogview" :visible.sync="dialogTableVisible" :close-on-click-modal="false"
				:title="$t('vehicleInfo.seeaccessoriesInfo')" :modal-append-to-body='false' style="font-size: 14px;
			color: #585858;">
				<el-descriptions :column="3" border class="descrip" style="overflow: auto; height:600px ;">

					<el-descriptions-item v-for="item in accessoriesinfolist" label-class-name="my-label"
						content-class-name="my-content" :key="item.key" :label="$t('vehicleInfo.' + item.key)"
						:contentStyle="{ 'color': (item.value == $t('state.effective')) ? '#07B477' : '#0F1A3A' }">
						<!-- 此处 detailList 后端返回的数据  -->
						{{ item.value }}
					</el-descriptions-item>
				</el-descriptions>
			</el-dialog>

			<el-dialog class="dialog" :visible.sync="dialogvehicleVisible"
				:title="$t('vehicleInfo.modifyaccessoriesInfo')" :modal-append-to-body='false'
				style="font-size: 14px; color: #585858;"
				:width="(LanguageId == 1 || LanguageId == 2) ? '528px' : '1060px'" :close-on-click-modal="false">
				<modify @newmodifyInfo="modifydata" @transmit="getMessage" :driverdata="driverdata"
					@canceldialog="canceldialog" :modifyInfo="modifyInfoCopy" :provicedata="provicedata">
				</modify>
				<el-dialog class="dialogadd" :visible.sync="visdialognewadd" append-to-body
					:close-on-click-modal="false">
					<div class="branchinfo">
						<span
							style="font-size: 12px;text-align: left;font-weight: bold !important;color: black;margin-left: 10px;">{{
								$t('vehicleInfo.newdriver') }}</span>
					</div>
					<el-form :model="neadddata" style="margin-top: 20px;" label-width="100px">
						<el-form-item :label="$t('vehicleInfo.drivername') + '：'">
							<el-input v-model="neadddata.drivername"
								:placeholder="$t('vehicleInfo.inputdrivername')"></el-input>
						</el-form-item>
						<el-form-item :label="$t('vehicleInfo.driverphone') + '：'">
							<el-input v-model="neadddata.drivertel"
								:placeholder="$t('operatormgr.please_opt_mobile')"></el-input>
						</el-form-item>
						<el-form-item :label="$t('vehicleInfo.affiliatedcompany') + '：'">
							<el-select v-model="neadddata.affiliatedcompany"
								:placeholder="$t('vehicleInfo.selectcompany')">
								<el-option v-for="(val, key) in affcompanyList" :key="val.index" :label="val.label"
									:value="val.label"></el-option>

							</el-select>
						</el-form-item>

					</el-form>
					<div slot="footer" class="dialog-footer">
						<el-button size="mini" @click="visdialognewadd = false">{{ $t('public.cancel') }}</el-button>
						<el-button size="mini" type="primary" @click="driveradd">{{ $t('public.add') }}</el-button>
					</div>
				</el-dialog>
			</el-dialog>
		</div>
	</div>
</template>
<script>
import {
	mapState
} from 'vuex'
import modify from "./modifyVehicleInfo.vue"
import language from '@/utils/getLanguageId';
export default {
	name: "vehicleInfo",
	components: {
		modify
	},
	data() {
		return {
			loading: false,
			LanguageId: 1,
			affcompanyList: [],
			current_page: 0,
			current_event_page: 1,
			pageSize: 10,
			totalEventCount: 0,
			provicedata: [],
			driverdata: [],
			cityList: [],
			neadddata: {
				drivername: "",
				drivertel: ''
			},
			form: {},
			visdialognewadd: false,
			formLabelWidth: '232px',
			textcolor: '',
			accessoriesinfolist: [],
			vehicleInfo: "",
			tableData: [],
			EventData: [],
			dialogTableVisible: false,
			dialogvehicleVisible: false,
			nmodifyvid: 0,
			modifyInfo: {},
			modifyInfoCopy: {},
			searchvalue: ""
		}
	},
	mounted() {
		// const companyID = localStorage.getItem('companyId');
		this.LanguageId = language(this.$store.getters.locale);
		this.queryvelist();
		//查驾驶员列表
		this.$api.querydriver({
			companyID: this.operator.CompanyId
		}).then((res) => {
			if (res.data.length > 0) {

				let newdata = res.data.map((val) => {
					return {
						label: val.drivername,
						value: val.driverid
					}
				})
				this.driverdata = newdata;
			}
		})
		//查省份
		// this.$api.queryProvince({

		// }).then((res) => {
		// 	if (res.data.length > 0) {
		// 		console.log(res)
		// 		let newprovince = res.data.map((val) => {
		// 			return {
		// 				label: val.provincename,
		// 				value: val.provinceid
		// 			}
		// 		})
		// 		this.provicedata = newprovince;
		// 	}
		// })
		//分公司
		// var newbranchoffice=localStorage.getItem('branchoffice');
		//待改，看是在接口还是缓存获取

		this.$api.queryBranchInfo({
			companyID: this.operator.CompanyId,
		}).then((res) => {
			console.log(res)
			if (res.data.length > 0) {
				let newbranchoffice = res.data.map((item) => {
					return {
						label: item.branchname,
						value: item.branchofficeID
					}
				})
				this.affcompanyList = newbranchoffice;
			}
		})
	},
	computed: {
		size() {
			return this.$store.getters.size
		},
		...mapState({
			operator: state => state.user.operator,
		})
	},
	watch: {
		// current_event_page() {
		// 	//计算显示gps数据
		// 	this.tableData = [];
		// 	var start = (this.current_event_page - 1) * this.pageSize;
		// 	var end = start + this.pageSize;
		// 	var data = this.EventData.slice(start, end);
		// 	// console.log(data);
		// 	this.tableData = data;

		// },
		// dialogvehicleVisible(newval){
		// 	if(!newval){
		// 		location.reload();
		// 	}
		// }

	},
	methods: {
		canceldialog(val) {
			this.dialogvehicleVisible = val;
		},
		open2(message1) {
			this.$message({
				message: message1,
				type: 'success'
			});
		},
		open3(message) {
			this.$message({
				message: message,
				type: 'warning'
			});
		},
		driveradd() {
			// this.visdialognewadd = false;
			if (Object.keys(this.neadddata).length == 0) {
				this.open3(this.$t('vehicleInfo.adddriverfail'));
			} else {
				this.$api.newdriver({
					drivername: this.neadddata.drivername,
					telphone: this.neadddata.drivertel,
					affiliatedcompany: this.neadddata.affiliatedcompany
				}).then((res) => {
					console.log(res)
					if (res && res.code == 200) {
						this.visdialognewadd = false;
						this.open2(this.$t('public.add_success'));
					} else {
						this.open3(this.$t('organstructure.addfail'));
					}

				})

			}
		},
		initEventData() {
			this.totalEventCount = this.EventData.length;
			this.current_event_page = 1;
		},

		handleEventCurrentChange(page) {
			this.current_event_page = page;
			this.tableData = [];
			this.queryvelist(this.searchvalue);
		},
		viewClick(val) {
			console.log(val)
			this.dialogTableVisible = true;
			this.$api.queryAccessoriesinfoList({
				vID: val.vID
			}).then((res) => {
				if (res.data.length > 0) {
					this.accessoriesinfolist = res.data
				}
			})

		},
		modifyClick(val) {
			this.nmodifyvid = val.vID;
			this.dialogvehicleVisible = true;
			this.modifyInfoCopy = JSON.parse(JSON.stringify(val));
			// this.tableData.forEach((item) => {
			// 	console.log()
			// 	if (item.vID == val.vID) {
			// 		if (item.buydate == '1900-01-01 00:00:00') {
			// 			item.buydate = '';
			// 		}
			// 		this.modifyInfo = item;
			// 	}
			// })
			if (this.modifyInfoCopy.buydate == '1900-01-01 00:00:00') {
				this.modifyInfoCopy.buydate = '';
			}
		},
		//查询
		onSubmit(val) {
			console.log(val);
			this.searchvalue = val;
			this.initEventData();
			this.queryvelist(this.searchvalue);
		},

		modifydata(modidata) {
			console.log(modidata)
			console.log(modidata.defaultDriver)
			let formattedBuyDate = '';
			if (modidata.buydate) {
				const date = new Date(modidata.buydate);
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份0-11，补0
				const day = String(date.getDate()).padStart(2, '0'); // 日期补0
				const hours = String(date.getHours()).padStart(2, '0'); // 小时补0
				const minutes = String(date.getMinutes()).padStart(2, '0'); // 分钟补0
				const seconds = String(date.getSeconds()).padStart(2, '0'); // 秒补0
				formattedBuyDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			} else {
				// 空日期用默认值（与表格初始空值逻辑一致）
				formattedBuyDate = '1900-01-01 00:00:00';
			}
			//保存修改的数据
			this.$api.modifyVehicleInfo({
				vID: this.nmodifyvid,
				manufactureId: modidata.manufactureId,
				vin: modidata.vin,
				modellevel: modidata.modellevel,
				carno: modidata.carno,
				province: modidata.province,
				industry: modidata.industry,
				buydate: formattedBuyDate,
				// vehicleownerinfo: modidata.vehicleownerinfo,
				roadTransCerNo: modidata.roadTransCerNo,
				businessArea: modidata.businessArea,
				operationalstatus: modidata.operationalstatus,
				electricityprice: modidata.electricityprice,
				deviceNo: modidata.deviceNo,
				vehicleModel: modidata.vehicleModel,
				vehicleselfNo: modidata.vehicleselfNo,
				vehicleColor: modidata.vehicleColor,
				city: modidata.city,
				deviceType: modidata.deviceType,
				usedate: modidata.usedate,
				defaultDriver: modidata.driver,
				businesslicenseNo: modidata.businesslicenseNo,
				// linetype: modidata.linetype,
				// oilprice: modidata.oilprice,
				// gasprice: modidata.gasprice,
				runState: modidata.runState
			}).then((res) => {
				console.log(res)
				if (res && res.code == 200) {
					this.dialogvehicleVisible = false;

					const targetIndex = this.tableData.findIndex(item => item.vID === this.nmodifyvid);
					if (targetIndex !== -1) {

						const updatedRow = JSON.parse(JSON.stringify(modidata));
						updatedRow.buydate = formattedBuyDate;
						this.tableData.splice(targetIndex, 1, updatedRow);
					}
					this.open2(this.$t('public.hasSaved'));
					this.modifyInfoCopy = {};
				}
			})
		},
		queryvelist(val) {
			this.loading = true;
			this.$api.queryVehicleinfoList({
				companyID: this.operator.CompanyId,
				pageNo: this.current_event_page,
				pageSize: this.pageSize,
				BranchName: val,
				OperatorID: this.$store.getters.operator.OperatorId,
			}).then((res) => {
				if (res.code == 200) {
					this.tableData = res.data;
					this.totalEventCount = res.recordsTotal;
					this.loading = false;
					// this.EventData = res.data;
					// this.initEventData();
				}
			}).catch((e) => {
				this.loading = false;
				this.tableData = [];
				this.totalEventCount = 0;
			})
		},
		getMessage(data) {
			this.visdialognewadd = data;
		},
	},
}
</script>
<style lang="scss" scoped>
.el-form-item {
	margin-bottom: 0px !important;
}

.dialogadd {
	::v-deep .el-dialog {
		width: 312px;
		height: 284px;
	}
}

.dialogadd {
	::v-deep .el-select-dropdown__item {
		font-size: 12px;
	}
}


.dialogadd {
	::v-deep .el-select .el-input.is-focus .el-input__inner {
		font-size: 12px;
	}
}

.dialogadd {
	::v-deep .el-form-item__label {
		font-size: 12px;
	}
}

.dialogadd {
	::v-deep .el-form-item__content {
		font-size: 12px;
	}
}

.dialogadd {
	::v-deep .el-input--suffix .el-input__inner {
		font-size: 12px;
	}
}

.dialogadd {
	::v-deep .el-input__inner {
		width: 160px;
		height: 28px;
	}
}

.dialogadd {
	::v-deep .el-dialog__body {
		margin-bottom: 0px;
	}
}



.dialogview {
	::v-deep .el-dialog {
		width: 1086px;
		height: 710px;

	}
}

.dialog {
	::v-deep .el-dialog__title {
		font-size: 14px;
		color: black;
		font-weight: bold;
	}
}

.dialog {
	::v-deep .el-dialog__body {
		padding: 0px 40px 40px 40px;

	}
}

.page_header {
	margin-top: 30px;
	display: flex;
	align-items: center;
}

.descrip {
	border-bottom: 1px solid #C5D0E2;
	border-right: 1px solid #C5D0E2;
	border-left: 1px solid #C5D0E2;

}

.descrip {
	::v-deep .my-label {
		background: rgba(232, 240, 255, 0.50);
		;
		border-color: #C5D0E2;
		// border-top: 1px solid #C5D0E2;
		border-bottom: 1px solid #D9E4F8;
		border-right: 1px solid #D9E4F8;
		border-left: 1px solid #D9E4F8;
		font-size: 12px;
		color: #0F1A3A;
		text-align: right;

	}

}

.descrip {
	::v-deep .my-content {
		border-color: #C5D0E2;
		// border-top: 1px solid #C5D0E2;
		border-bottom: 1px solid #D9E4F8;
		border-right: 1px solid #D9E4F8;
		border-left: 1px solid #D9E4F8;
		color: #0F1A3A;
		font-size: 12px;
	}
}

.vehicleclass {
	::v-deep .el-input__inner {
		font-size: 12px;
		width: 280px;
	}
}

.page_container {
	margin-top: 20px;

	::v-deep .el-table tr {
		background: transparent;
	}

	::v-deep .el-table {
		background: transparent;
	}

	::v-deep .el-table td {
		background: transparent;
	}
}

::v-deep .el-table__fixed,
.el-table__fixed-left {
	background-color: #fff !important;
}

::v-deep .el-table__fixed-right {
	background-color: #F4F8FF !important;
}
</style>